import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  DistributionReasonDTO,
  useWithdrawalOptionsQuery,
} from '../../../../api/useWithdrawalOptionsQuery';
import {
  DISTRIBUTION_REASONS_TITLES,
  FormValues,
  PRIMARY_DISTRIBUTION_REASONS,
  validation,
} from './WithdrawSelection.meta';

interface UseWithdrawSelectionProps {
  onDistributionReasonChange(distributionReason: DistributionReasonDTO): void;
}

export const useWithdrawSelection = ({ onDistributionReasonChange }: UseWithdrawSelectionProps) => {
  const queryResult = useWithdrawalOptionsQuery();

  const primaryDistributionReasons = PRIMARY_DISTRIBUTION_REASONS.reduce((acc, value) => {
    const primaryDistributionReason = queryResult.data?.distributionReasons?.find(
      reason => reason.value === value,
    );

    if (primaryDistributionReason) {
      return [...acc, primaryDistributionReason];
    }

    return acc;
  }, [] as DistributionReasonDTO[]);

  const otherDistributionReasons = queryResult.data?.distributionReasons
    ?.filter(({ value }) => !PRIMARY_DISTRIBUTION_REASONS.includes(value))
    .map(reason => ({ ...reason, label: DISTRIBUTION_REASONS_TITLES[reason.value] }));

  const formBag = useForm<FormValues>({
    defaultValues: {
      distributionReason: primaryDistributionReasons[0],
    },
    resolver: yupResolver(validation),
  });

  const distributionReason = formBag.watch('distributionReason');

  const isOtherDistributionSelected = !primaryDistributionReasons.some(
    ({ value }) => distributionReason?.value === value,
  );

  const onSubmit = (values: FormValues) => {
    if (values.distributionReason) {
      onDistributionReasonChange(values.distributionReason);
    }
  };

  return {
    data: {
      formBag,
      primaryDistributionReasons,
      otherDistributionReasons,
      isOtherDistributionSelected,
    },

    actions: {
      onSubmit,
    },
  };
};
